import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useTranslate from '../../../core/languages/hooks/useTranslate';
import InputField from '../../../ui/components/InputField/InputField';

interface NumberOfPassengersProps {
    name: string; // "arrivalNumberOfPassengers" or "departureNumberOfPassengers"
    direction?: 'arrival' | 'departure';
}

/**
 * Reusable component for number of passengers field
 * Receives the field name and direction for dynamic label
 */
const NumberOfPassengers: React.FC<NumberOfPassengersProps> = ({ name, direction = 'arrival' }) => {
    const t = useTranslate();
    const { control, formState: { errors } } = useFormContext();

    // Build the label key dynamically based on direction
    const labelKey = direction === 'departure' 
        ? 'transfers.fields.departureNumberOfPassengers'
        : 'transfers.fields.arrivalNumberOfPassengers';

    return (
        <Controller
            name={name}
            control={control}
            rules={{
                required: t("common.feedback.field_required"),
                min: { value: 1, message: t("common.feedback.field_min_length", {length: 1}) },
                max: { value: 100, message: t("common.feedback.field_max_length", {length: 100}) }
            }}
            render={({ field }) => (
                <InputField
                    {...field}
                    label={t(labelKey)}
                    type="number"
                    min="1"
                    max="100"
                    error={(errors as any)[name]?.message}
                />
            )}
        />
    );
};

export default NumberOfPassengers;

